export class SettingItem<T> {
    public name: string;
    public value: T;

    constructor(data?: any) {
        this.name = data && data.name ? data.name : '';
        this.value = data && data.value ? data.value : null;
    }
}
